import { Bleedable } from '@fs/zion-ui'
import React, { type ReactNode } from 'react'
import { MARGIN_Y_DEFAULT } from './common'

type Props = {
  children: ReactNode
}

export default function MergeSquareCardMarginBoxY({ children }: Props): JSX.Element {
  return (
    <Bleedable top={MARGIN_Y_DEFAULT} bottom={MARGIN_Y_DEFAULT}>
      {children}
    </Bleedable>
  )
}
